'use strict';

module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./node_modules/remarkable/index.js
// module id = 420
// module chunks = 0